import { Const } from '../lib/const.cls'

export const mutations = {
	[Const.SET_COMMISSION_LIST] (state, data) {	try {state.getcommissionlist = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_COUNTRIES_LIST] (state, data) {	try {state.countriesList = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_CITIES_LIST] (state, data) {	try {state.citiesList = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_CLIENT_DATA] (state, data) {	try {state.getClientData = data} catch (ex) {console.debug('set state EX', ex)}	},

	[Const.SET_VPS_LIST] (state, data) {	try {state.vpsList = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_SUBSCRIPTION_LIST] (state, data) {	try {state.subscriptionList = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_SUBSCRIPTION_DETAIL] (state, data) {	try {state.subscriptionDetail = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_USER_OTHER_DETAILS] (state, data) {	try {state.userOtherDetail = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_LOYALITY_TRANSACTION_LIST] (state, data) {	try {state.transactionList = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_LOYALITY_CARD_LIST] (state, data) {	try {state.cardList = data} catch (ex) {console.debug('set state EX', ex)}	},
	
	//ib
	[Const.SET_IB_LIST] (state, data) {									
		try {
			state.iblist = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//ib change list
	[Const.SET_IB_CHANGE_LIST] (state, data) {									
		try {
			state.ibchangelist = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//Sub Ib
	[Const.SET_SUB_IB_LIST] (state, data) {									
		try {
			state.subiblist = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_IB_VIEW] (state, data) {									
		try {
			state.ibView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//permission
	[Const.SET_PERMISSION_LIST] (state, data) {									
		try {
			state.permission = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	[Const.SET_EMAIL_DATA] (state, data) {									
		try {
			state.emailData = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//email
	[Const.SET_EMAIL_SETTING_LIST] (state, data) {									
		try {
			state.emailList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//coupon
	[Const.SET_COUPON_LIST] (state, data) {									
		try {
			state.couponList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	
	//admin
	[Const.SET_ADMIN_LIST] (state, data) {									
		try {
			state.adminList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ALL_NOTIFICATION_DATA] (state, data) {									
		try {
			state.notificationList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_UNREAD_NOTIFICATION_DATA] (state, data) {									
		try {
			state.notificationListUnread = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_NOTIFICATION_OLD_LIST] (state, data) {									
		try {
			state.notificationListOld = data
		} catch (ex) {
			console.debug('set state EX', ex)
		
		}
	},
	[Const.SET_LOGS_LIST] (state, data) {									
		try {
			state.logsList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_LOGS_VIEW] (state, data) {									
		try {
			state.logsView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ADMIN_DETAIL] (state, data) {									
		try {
			state.adminDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//client
	[Const.SET_USER_GROUP_ID] (state, data) {									
		try {
			state.userGroupId = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_GROUP_ADMIN_NAME] (state, data) {									
		try {
			state.groupAdminName = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_METHODS] (state, data) {									
		try {
			state.withdrawalMethods = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_METHOD_RESPONSE] (state, data) {									
		try {
			state.withdrawalMethodResponse = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ARTICLE_LIST] (state, data) {									
		try {
			state.articleList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_CAT_LIST] (state, data) {									
		try {
			state.catList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_LIST] (state, data) {									
		try {
			state.userList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_VIEW] (state, data) {									
		try {
			state.userView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_COUNT] (state, data) {									
		try {
			state.userCount = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_INTERNAL_NOTES] (state, data) {									
		try {
			state.internalNotes = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_RISK_METRIX] (state, data) {									
		try {
			state.riskMetrix = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//deposit
	[Const.SET_DEPOSIT_LIST]: (state, data) => {		
		try {
			state.depositList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEPOSIT_VIEW]: (state, data) => {		
		try {
			state.depositView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//bonus
	[Const.SET_BONUS_LIST]: (state, data) => {		
		try {
			state.bonusList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_BONUS_VIEW]: (state, data) => {		
		try {
			state.bonusView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	// internal ticket
	[Const.SET_INTERNAL_TICKET_REASON]: (state, data) => {		
		try {
			state.internalReasonList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//ticket
	[Const.SET_TICKET_LIST]: (state, data) => {		
		try {
			state.ticketList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_REASON_LIST]: (state, data) => {		
		try {
			state.ticketReasonList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	[Const.SET_TICKET_REASON_LIST1]: (state, data) => {		
		try {
			state.ticketReasonList1 = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_VIEW]: (state, data) => {		
		try {
			state.ticketView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_DOCS]: (state, data) => {		
		try {
			state.ticketDocs = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	[Const.SET_TICKET_DATA]: (state, data) => {	
		try {
			state.ticketData = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//withdrawal
	[Const.SET_WITHDRAWAL_LIST]: (state, data) => {	
		try {
			state.withdrawalList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_LIST_MAKER]: (state, data) => {	
		try {
			state.withdrawalListMaker = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_VIEW]: (state, data) => {	
		try {
			state.withdrawalView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//trading
	[Const.SET_TRADING_LIST]: (state, data) => {	
		try {
			state.tradingList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TRADING_VIEW]: (state, data) => {	
		try {
			state.tradingView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//tutorials
	[Const.SET_TUTORIAL_LIST]: (state, data) => {	
		try {
			state.tutorialList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TUT_COURSE]: (state, data) => {	
		try {
			state.tutorialCourse = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TUT_CAT]: (state, data) => {	
		try {
			state.tutorialCat = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//trading education
	[Const.SET_CATEGORY_LIST]: (state, data) => {	
		try {
			state.categoryList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_POST_LIST]: (state, data) => {	
		try {
			state.postList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	[Const.SET_UPLOADS_LIST]: (state, data) => {	
		try {
			state.uploadsList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	[Const.SET_COMMISSION_REPORT_LIST] (state, data) {	try {state.commissionReportList = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_COMMISSION_WITHDRAWAL_LIST] (state, data) {	try {state.commissionWithdrawalList = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_COMMISSION_REPORT_DETAIL] (state, data) {	try {state.commissionReportDetail = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_CLIENT_LEADS] (state, data) {	try {state.clientLeads = data} catch (ex) {console.debug('set state EX', ex)}	},

	[Const.SET_ADMIN_DEPOSIT_METHODS] (state, data) {	try {state.depositMethods = data} catch (ex) {console.debug('set state EX', ex)}	},
	[Const.SET_LOYALITY_POINT_COUNT] (state, data) {	try {state.loyalityCount = data} catch (ex) {console.debug('set state EX', ex)}	},


}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/mutations.js